var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video)?_c('div',{staticClass:"hero-video"},[_c('video',{staticClass:"d-block black",attrs:{"poster":_vm.img,"src":_vm.files + _vm.video,"autoplay":"","loop":"","muted":""},domProps:{"muted":true}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }